module.exports = __webpack_public_path__ + "images/emoji/roller_coaster.a9d2572d311c1188433b.png";